import React from "react";
import {css} from "@emotion/css";


const RaikoBaseCardContainer = ({children, className}) => {
    return (
        <section
            className={`default-card-container-background-style ${css`
              padding: 16px;
              display: flex;
              flex-direction: column;
            `} ${className}`}>
            {children}
        </section>
    )
}

export default RaikoBaseCardContainer